export const defaultSystemRolesPermissions = [
    'log-in',
    'view-organizations',
    'view-user-directory',
    'manage-profile-picture',
];
export const defaultSystemRoles = {
    'system-admin': {
        level: 99,
        label: 'Juvare System Admin',
        permissions: [
            'all-organizations-admin',
            'view-groups',
            'view-group-history',
            'import-groups',
            'export-groups',
            'manage-groups',
            'view-invisible-organizations',
            'import-organizations',
            'export-organizations',
            'view-organization-history',
            'view-account-history',
            'manage-accounts-organizations',
            'manage-organizations',
            'manage-settings',
            'manage-accounts',
            'change-account-systemRole',
            'list-all-accounts',
            'switch-to-account',
            'export-accounts',
            'import-accounts',
            'manage-editable-pages',
            'manage-system-settings',
            'manage-configurable-lists',
            'manage-dynamic-columns',
            'manage-all-classifiers',
            'allow-reset-okta-password-email',
            'allow-reset-okta-mfa',
            'allow-unlock-okta-account',
            'allow-change-login-email',
            'view-system-admin-accounts',
            ...defaultSystemRolesPermissions,
        ],
    },
    'client-admin': {
        level: 98,
        label: 'Client Admin',
        permissions: [
            'all-organizations-admin',
            'view-groups',
            'view-group-history',
            'import-groups',
            'export-groups',
            'manage-groups',
            'view-invisible-organizations',
            'import-organizations',
            'export-organizations',
            'view-organization-history',
            'view-account-history',
            'manage-accounts-organizations',
            'manage-organizations',
            'manage-settings',
            'manage-accounts',
            'change-account-systemRole',
            'list-all-accounts',
            'export-accounts',
            'import-accounts',
            'manage-editable-pages',
            'allow-reset-okta-password-email',
            'allow-reset-okta-mfa',
            'allow-unlock-okta-account',
            'allow-change-login-email',
            ...defaultSystemRolesPermissions,
        ],
    },
    user: {
        level: 2,
        label: 'Regular User',
        default: true,
        permissions: [...defaultSystemRolesPermissions],
    },
    contact: {
        level: 1,
        label: 'Contact',
        permissions: [],
    },
};
